import request from '@/utils/request'

export function updateShopCfg(data) {
  return request({
    url: 'api/v1/shop/updateShopList',
    method: 'post',
    data: data
  })
}

export function updateShopGoodsCfg(data) {
  return request({
    url: 'api/v1/shop/updateShopGoods',
    method: 'post',
    data: data
  })
}

export function getShopCfgList(data) {
  return request({
    url: 'api/v1/shop/getShopList',
    method: 'post',
    data: data
  })
}

export function getFirstPayRefreshCfg() {
  return request({
    url: 'api/v1/shop/getFirstPayRefreshCfg',
    method: 'get'
  })
}

export function updateFirstPayRefresh(data) {
  return request({
    url: 'api/v1/shop/updateFirstPayRefreshCfg',
    method: 'post',
    data: data
  })
}

export function getCountryMap() {
  return request({
    url: 'api/v1/shop/getCountry',
    method: 'get'
  })
}

export function getShopGoodsList(data) {
  return request({
    url: 'api/v1/shop/getShopGoodsList',
    method: 'post',
    data: data
  })
}

export function exportShopCfg(data) {
  return request({
    url: 'api/v1/shop/exportShop',
    method: 'post',
    data: data
  })
}

export function exportShopPrizeCfg() {
  return request({
    url: 'api/v1/shop/exportShopPrize',
    method: 'get'
  })
}

export function importShopCfg(data) {
  return request({
    url: 'api/v1/shop/importShop',
    method: 'post',
    data: data
  })
}

export function importShopPrizeCfg(data) {
  return request({
    url: 'api/v1/shop/importShopPrize',
    method: 'post',
    data: data
  })
}

export function deleteShopCfg(data) {
  return request({
    url: 'api/v1/shop/delShopCfg',
    method: 'delete',
    data: data
  })
}

export function deleteShopGoodsCfg(data) {
  return request({
    url: 'api/v1/shop/delShopGoodsCfg',
    method: 'delete',
    data: data
  })
}

export function getShopType() {
  return request({
    url: 'api/v1/shop/shopType',
    method: 'get'
  })
}

export function getGiftList(data) {
  return request({
    url: 'api/v1/shop/getGiftList',
    method: 'post',
    data: data
  })
}

export function giftAsyncOss(data) {
  return request({
    url: 'api/v1/shop/giftRuleSyncOss',
    method: 'post',
    data: data
  })
}

export function updateRuleGiftList(data) {
  return request({
    url: 'api/v1/shop/updateGiftList',
    method: 'post',
    data: data
  })
}

export function getRuleGiftList(data) {
  return request({
    url: 'api/v1/shop/getGiftListPage',
    method: 'post',
    data: data
  })
}

export function delRuleGiftCond(data) {
  return request({
    url: 'api/v1/shop/delGiftCond',
    method: 'delete',
    data: data
  })
}

export function getSku(data) {
  return request({
    url: 'api/v1/shop/getSku',
    method: 'post',
    data: data
  })
}

export function updateSkuTon(data) {
  return request({
    url: 'api/v1/shop/updateSkuTon',
    method: 'post',
    data: data
  })
}

export function syncSkuOss(data) {
  return request({
    url: 'api/v1/shop/syncSkuOss',
    method: 'post',
    data: data
  })
}

export function getShopSku() {
  return request({
    url: 'api/v1/shop/shopSku',
    method: 'get'
  })
}

